import { render, staticRenderFns } from "./mall_coin.vue?vue&type=template&id=ad3bdc4c&scoped=true"
import script from "./mall_coin.vue?vue&type=script&lang=ts"
export * from "./mall_coin.vue?vue&type=script&lang=ts"
import style0 from "./mall_coin.vue?vue&type=style&index=0&id=ad3bdc4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3bdc4c",
  null
  
)

export default component.exports